import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MetabaseInfoBlockDashboardEmbedUrlQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  recordId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  code?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type MetabaseInfoBlockDashboardEmbedUrlQuery = { __typename: 'PharosQuery', metabaseInfoBlockDashboard: { __typename: 'MetabaseInfoBlockDashboardType', id: string, name: string, embedUrl: string | null } | null };


export const MetabaseInfoBlockDashboardEmbedUrlDocument = gql`
    query metabaseInfoBlockDashboardEmbedUrl($id: ID!, $recordId: ID, $code: String) {
  metabaseInfoBlockDashboard(id: $id) {
    id
    name
    embedUrl(recordId: $recordId, publicFormCode: $code)
  }
}
    `;

/**
 * __useMetabaseInfoBlockDashboardEmbedUrlQuery__
 *
 * To run a query within a React component, call `useMetabaseInfoBlockDashboardEmbedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetabaseInfoBlockDashboardEmbedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetabaseInfoBlockDashboardEmbedUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      recordId: // value for 'recordId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useMetabaseInfoBlockDashboardEmbedUrlQuery(baseOptions: Apollo.QueryHookOptions<MetabaseInfoBlockDashboardEmbedUrlQuery, MetabaseInfoBlockDashboardEmbedUrlQueryVariables> & ({ variables: MetabaseInfoBlockDashboardEmbedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetabaseInfoBlockDashboardEmbedUrlQuery, MetabaseInfoBlockDashboardEmbedUrlQueryVariables>(MetabaseInfoBlockDashboardEmbedUrlDocument, options);
      }
export function useMetabaseInfoBlockDashboardEmbedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetabaseInfoBlockDashboardEmbedUrlQuery, MetabaseInfoBlockDashboardEmbedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetabaseInfoBlockDashboardEmbedUrlQuery, MetabaseInfoBlockDashboardEmbedUrlQueryVariables>(MetabaseInfoBlockDashboardEmbedUrlDocument, options);
        }
export function useMetabaseInfoBlockDashboardEmbedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetabaseInfoBlockDashboardEmbedUrlQuery, MetabaseInfoBlockDashboardEmbedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetabaseInfoBlockDashboardEmbedUrlQuery, MetabaseInfoBlockDashboardEmbedUrlQueryVariables>(MetabaseInfoBlockDashboardEmbedUrlDocument, options);
        }
export type MetabaseInfoBlockDashboardEmbedUrlQueryHookResult = ReturnType<typeof useMetabaseInfoBlockDashboardEmbedUrlQuery>;
export type MetabaseInfoBlockDashboardEmbedUrlLazyQueryHookResult = ReturnType<typeof useMetabaseInfoBlockDashboardEmbedUrlLazyQuery>;
export type MetabaseInfoBlockDashboardEmbedUrlSuspenseQueryHookResult = ReturnType<typeof useMetabaseInfoBlockDashboardEmbedUrlSuspenseQuery>;
export type MetabaseInfoBlockDashboardEmbedUrlQueryResult = Apollo.QueryResult<MetabaseInfoBlockDashboardEmbedUrlQuery, MetabaseInfoBlockDashboardEmbedUrlQueryVariables>;